// src/utils/visitorTracker.js
let hasRecorded = false;

export const recordVisitor = () => {
    const consent = localStorage.getItem('usage_tracking_consent');
    if (consent !== 'granted') return; // Respect user choice

    if (hasRecorded) return;
    hasRecorded = true;
    //loadGoogleAnalytics();

    fetch('/api/visit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            path: window.location.pathname
        })
    }).catch(err => console.warn('Visitor tracking failed', err));
};

declare global {
    interface Window {
        dataLayer: any[];
        gtag?: (...args: any[]) => void;
    }
}

// @ts-ignore  //todo Test and use
function loadGoogleAnalytics(): void {
    const script = document.createElement('script');
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-LL7W6C3QR1";
    document.head.appendChild(script);

    script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag(...args: any[]) {
            window.dataLayer.push(args);
        }
        window.gtag = gtag;

        gtag('js', new Date());
        gtag('config', 'G-LL7W6C3QR1');
    };
}